import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "email",
    "password",
    "nextButton",
    "signUpButton",
    "emailError",
    "passwordError",
    "passwordInfo",
    "termsCheckbox",
  ];

  connect() {
    this.debouncedValidate = this.#debounce(this.validateForm.bind(this), 400);
  }

  validateForm() {
    const email = this.emailTarget?.value || "";
    const password = this.passwordTarget?.value || "";

    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const passwordValid =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(password);
    const termsAccepted = this.termsCheckboxTarget.checked;

    // check if email already exists
    this.checkEmail();

    // check email validity
    if (this.hasEmailErrorTarget) {
      if (!email && this.emailErrorTarget) {
        this.emailErrorTarget.classList.add("hidden");
      } else if (!emailValid) {
        this.emailErrorTarget.textContent = "Enter a valid email.";
        this.emailErrorTarget.classList.remove("hidden");
      } else {
        this.emailErrorTarget.classList.add("hidden");
      }
    }

    if (this.hasPasswordErrorTarget) {
      if (!password && this.passwordErrorTarget) {
        this.passwordInfoTarget.classList.remove("hidden");
        this.passwordErrorTarget.classList.add("hidden");
      } else if (!passwordValid) {
        this.passwordInfoTarget.classList.add("hidden");
        this.passwordErrorTarget.classList.remove("hidden");
      } else {
        this.passwordInfoTarget.classList.remove("hidden");
        this.passwordErrorTarget.classList.add("hidden");
      }
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = !(
        emailValid &&
        passwordValid &&
        termsAccepted
      );
      if (!(emailValid && passwordValid && termsAccepted)) {
        this.nextButtonTarget.classList.remove("bg-brand-600", "text-white");
        this.nextButtonTarget.classList.add("bg-gray-100", "text-gray-400");
      }

      if (emailValid && passwordValid && termsAccepted) {
        this.nextButtonTarget.classList.remove("bg-gray-100", "text-gray-400");
        this.nextButtonTarget.classList.add("bg-brand-600", "text-white");
      }
    }
  }

  async checkEmail() {
    const email = this.emailTarget?.value || "";
    if (!email) return;

    try {
      const response = await fetch(
        `/users/check_email?email=${encodeURIComponent(email)}`,
        { headers: { Accept: "application/json" } }
      );
      const data = await response.json();

      if (data.exists && this.hasEmailErrorTarget) {
        this.nextButtonTarget.disabled = true;
        this.nextButtonTarget.classList.toggle("bg-gray-200");
        this.emailErrorTarget.textContent =
          "This email is already use in our system. Reset password or use a different email.";
        this.emailErrorTarget.classList.remove("hidden");
      }
    } catch (error) {
      console.error("Error checking email:", error);
    }
  }

  // i guess is not a bad idea this function to be private hence the # prefix
  #debounce(func, wait) {
    let timeout;
    return (...args) => {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
